import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import Header from '../../components/Header'
import { supabase } from '../../supabaseClient'
import { useNavigate } from 'react-router-dom'
import { authHeaders } from '../../utils/authFetch'

if (typeof document !== 'undefined' && !document.getElementById('shimmer-keyframes')) {
    const style = document.createElement('style')
    style.id = 'shimmer-keyframes'
    style.innerHTML = `
        @keyframes shimmer {
            0% { background-position: -400px 0; }
            100% { background-position: 400px 0; }
        }
    `
    document.head.appendChild(style)
}

// ─── Design tokens ────────────────────────────────────────────────────
const C = {
    espresso: 'transparent',
    dark: '#F9FAFB',
    card: '#FFFFFF',
    border: '#E5E7EB',
    muted: '#9CA3AF',
    text: '#111827',
    textSoft: '#6B7280',
    amber: '#D97706',
    gold: '#B45309',
    teal: '#0D9488',
    coral: '#DC2626',
    blue: '#2563EB',
    green: '#16A34A',
    purple: '#7C3AED',
    indigo: '#4F46E5',
    nude: '#A0826D',
    midgrey: '#6B7280',
}

const SkeletonBlock = ({ className = '', style = {} }) => (
    <div
        className={`rounded ${className}`}
        style={{
            backgroundImage: 'linear-gradient(90deg, #e5e7eb 0px, #f3f4f6 40px, #e5e7eb 80px)',
            backgroundSize: '400px 100%',
            animation: 'shimmer 1.4s ease-in-out infinite',
            ...style,
        }}
    />
)

const areSetsEqual = (a = new Set(), b = new Set()) => {
    if (a.size !== b.size) return false
    for (const v of a) if (!b.has(v)) return false
    return true
}

const EMPTY_BANNER = {
    title: '',
    subtitle: '',
    image_url: '',
    start_at: '',
    end_at: '',
    is_active: true,
    availability: 'permanent',
    linked_promotion_id: ''
}

const DOCUMENT_CATEGORIES = [
    { key: 'barangay_clearance', label: 'Barangay Business Clearance' },
    { key: 'mayors_permit', label: "Mayor's / Business Permit" },
    { key: 'sanitary_permit', label: 'Sanitary Permit & Health Certificates' },
    { key: 'fire_safety', label: 'Fire Safety Inspection Certificate' },
    { key: 'bir_registration', label: 'BIR Registration' },
]

function getBannerDisplayStatus(banner) {
    const today = new Date(); today.setHours(0, 0, 0, 0)
    if (!banner.is_active) return 'inactive'
    if (banner.start_at && new Date(banner.start_at) > today) return 'scheduled'
    if (banner.end_at && new Date(banner.end_at) < today) return 'expired'
    return 'active'
}

function getBannerStatusStyle(status) {
    switch (status) {
        case 'active': return 'bg-green-100 text-green-800'
        case 'scheduled': return 'bg-blue-100 text-blue-800'
        case 'expired': return 'bg-gray-100 text-gray-600'
        case 'inactive': return 'bg-yellow-100 text-yellow-800'
        default: return 'bg-gray-100 text-gray-800'
    }
}

export default function BranchManagement({ onGoToProfile }) {
    const [activeTab, setActiveTab] = useState('branches')
    const navigate = useNavigate();

    const [branchPage, setBranchPage] = useState(1)
    const [bannerPage, setBannerPage] = useState(1)
    const [archivedBranchPage, setArchivedBranchPage] = useState(1)
    const [archivedBannerPage, setArchivedBannerPage] = useState(1)
    const BRANCH_PAGE_SIZE = 9
    const BANNER_PAGE_SIZE = 10
    const ARCHIVE_PAGE_SIZE = 10

    // Branch
    const [branches, setBranches] = useState([])
    const [loading, setLoading] = useState(true)
    const [showAddModal, setShowAddModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [editingBranch, setEditingBranch] = useState(null)

    // Branch search + filter
    const [branchSearch, setBranchSearch] = useState('')
    const [branchStatusFilter, setBranchStatusFilter] = useState('all')
    const [branchStatusDropdownOpen, setBranchStatusDropdownOpen] = useState(false)

    // Branch archive viewer
    const [showArchivedBranchesModal, setShowArchivedBranchesModal] = useState(false)
    const [archivedBranches, setArchivedBranches] = useState([])
    const [loadingArchivedBranches, setLoadingArchivedBranches] = useState(false)
    const [archivedBranchSearch, setArchivedBranchSearch] = useState('')

    const [branchFormData, setBranchFormData] = useState({
        name: '',
        address: '',
        open_time: '',
        close_time: '',
        operating_start_date: '',
        status: 'operating',
        branch_owner: '',
        email: '',
        business_email: '',
        manager: '',
        tin: '',
        owner_is_manager: false,
        facebook_url: '',
        phone_number: '',
        telephone_number: '',
    })
    const [initialBranchFormData, setInitialBranchFormData] = useState(null)

  const EMPTY_BRANCH_FORM = {
        name: '',
        address: '',
        open_time: '',
        close_time: '',
        operating_start_date: '',
        status: 'operating',
        branch_owner: '',
        email: '',
        business_email: '',
        manager: '',
        tin: '',
        owner_is_manager: false,
        facebook_url: '',
        phone_number: '',
        telephone_number: '',
    }

    const [branchDocuments, setBranchDocuments] = useState([])
    const [newDocFilesByCategory, setNewDocFilesByCategory] = useState({}) 
    const [docsToDelete, setDocsToDelete] = useState([]) 
    const [loadingBranchDocs, setLoadingBranchDocs] = useState(false)

    const [banners, setBanners] = useState([])
    const [archivedBanners, setArchivedBanners] = useState([])
    const [bannerView, setBannerView] = useState('active')
    const [bannersLoading, setBannersLoading] = useState(false)
    const [bannerImageFile, setBannerImageFile] = useState(null)
    const [bannerImageMode, setBannerImageMode] = useState('upload')

    // Banner search
    const [bannerSearch, setBannerSearch] = useState('')

    const [showAddBannerModal, setShowAddBannerModal] = useState(false)
    const [showEditBannerModal, setShowEditBannerModal] = useState(false)
    const [editingBanner, setEditingBanner] = useState(null)

    const [bannerFormData, setBannerFormData] = useState(EMPTY_BANNER)
    const [initialBannerFormData, setInitialBannerFormData] = useState(null)

    // Banner archive viewer
    const [showArchivedBannersModal, setShowArchivedBannersModal] = useState(false)
    const [loadingArchivedBanners, setLoadingArchivedBanners] = useState(false)
    const [archivedBannerSearch, setArchivedBannerSearch] = useState('')

    // Branch selection for banners
    const [activeBranches, setActiveBranches] = useState([])
    const [selectedBranchIds, setSelectedBranchIds] = useState(new Set())
    const [initialSelectedBranchIds, setInitialSelectedBranchIds] = useState(new Set())

    const [promotions, setPromotions] = useState([])
    const [promotionSearch, setPromotionSearch] = useState('')
    const [promotionPickerPage, setPromotionPickerPage] = useState(1)
    const PROMOTION_PAGE_SIZE = 10

    const MAX = { title: 120, subtitle: 250 }

    const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'

    useEffect(() => {
        const style = document.createElement('style')
        style.innerHTML = `
            .swal2-confirm {
                background-color: #8B5A3C !important;
                border: none !important;
            }
            .swal2-confirm:hover {
                background-color: #6d4730 !important;
            }
            .swal2-cancel {
                background-color: #6b7280!important;
                border: none !important;
            }
                .swal2-cancel:hover {
            background-color: #5a5a5a !important;
            }
        `
        document.head.appendChild(style)
        return () => document.head.removeChild(style)
    }, [])

    useEffect(() => {
        const handler = (e) => {
            if (!e.target.closest('#branch-status-dropdown-wrapper')) {
                setBranchStatusDropdownOpen(false)
            }
        }
        document.addEventListener('mousedown', handler)
        return () => document.removeEventListener('mousedown', handler)
    }, [])

    // Initial load 
    useEffect(() => {
        fetchBranches()
        fetchBanners()
        fetchArchivedBanners()
        fetchPromotions()
    }, [])

    useEffect(() => 
        setBranchPage(1), [branchSearch, branchStatusFilter])

    useEffect(() =>
        setBannerPage(1), [bannerSearch])

    useEffect(() =>
        setArchivedBranchPage(1), [archivedBranchSearch])

    useEffect(() =>
        setArchivedBannerPage(1), [archivedBannerSearch])

    useEffect(() =>
        setPromotionPickerPage(1), [promotionSearch])

    // Branch CRUD
    const fetchBranches = async () => {
        try {
            setLoading(true)
            const { data, error } = await supabase
                .from('branches')
                .select('*')
                .neq('status', 'inactive')
                .order('created_at', { ascending: false })

            if (error) throw error

            setBranches(data || [])
            setActiveBranches((data || []).filter(b => b.status !== 'inactive'))
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to load branches', text: err.message })
        } finally {
            setLoading(false)
        }
    }

    const fetchArchivedBranches = async () => {
        try {
            setLoadingArchivedBranches(true)
            const { data, error } = await supabase
                .from('branches')
                .select('*')
                .eq('status', 'inactive')
                .order('created_at', { ascending: false })

            if (error) throw error
            setArchivedBranches(data || [])
        } catch (err) {
            console.error('Error fetching archived branches:', err)
        } finally {
            setLoadingArchivedBranches(false)
        }
    }


    const resetBranchForm = () => {
        setBranchFormData({
            name: '',
            address: '',
            open_time: '',
            close_time: '',
            operating_start_date: '',
            status: 'operating',
            branch_owner: '',
            email: '',
            business_email: '',
            manager: '',
            tin: '',
            owner_is_manager: false,
            facebook_url: '',
            phone_number: '',
            telephone_number: ''
        })
        setBranchDocuments([])
        setNewDocFilesByCategory({})
        setDocsToDelete([])
    }

    const handleAddBranch = async () => {
        const { name, address, open_time, close_time, operating_start_date, branch_owner, email, status } = branchFormData
         if (!name.trim() || !address.trim() || !open_time || !close_time || !operating_start_date || !branch_owner.trim() || !email.trim() || !status) {
            Swal.fire({ icon: 'warning', title: 'Missing Information', text: 'Please fill in all required fields.' })
            return
        }
        if (branchFormData.business_email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(branchFormData.business_email.trim())) {
            Swal.fire({ icon: 'warning', title: 'Invalid Business Email', text: 'Please enter a valid business email address.' })
            return
        }
        try {
            const { data, error } = await supabase
                .from('branches')
                .insert([{
                    name: name.trim(),
                    address: address.trim(),
                    open_time,
                    close_time,
                    operating_start_date,
                    status: branchFormData.status,
                    branch_owner: branchFormData.branch_owner.trim() || null,
                    email: branchFormData.email.trim() || null,
                    business_email: branchFormData.business_email.trim() || null,
                    manager: branchFormData.owner_is_manager
                        ? branchFormData.branch_owner.trim() || null
                        : branchFormData.manager.trim() || null,
                    tin: branchFormData.tin.trim() || null,
                    facebook_url: branchFormData.facebook_url.trim() || null,
                    phone_number: branchFormData.phone_number.trim() || null,
                    telephone_number: branchFormData.telephone_number.trim() || null,
                }])
                .select()
                .single()

            if (error) throw error

            // upload any staged documents
            /* --- Branch document upload (image/PDF) temporarily disabled ---
            for (const [category, files] of Object.entries(newDocFilesByCategory)) {
                for (const file of files) {
                    await uploadBranchDocument(file, data.branch_id, category)
                }
            }
            --- end disabled block --- */

            setShowAddModal(false); resetBranchForm(); fetchBranches()
            Swal.fire({ icon: 'success', title: 'Branch Added', timer: 1800, showConfirmButton: false })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Add Branch', text: err.message })
        }
    }

    const handleEditClick = (branch) => {
        setEditingBranch(branch)
        setBranchFormData({
            name: branch.name || '',
            address: branch.address || '',
            open_time: branch.open_time ? branch.open_time.slice(0, 5) : '',
            close_time: branch.close_time ? branch.close_time.slice(0, 5) : '',
            operating_start_date: branch.operating_start_date || '',
            status: branch.status || 'operating',
            branch_owner: branch.branch_owner || '',
            email: branch.email || '',
            business_email: branch.business_email || '',
            manager: branch.manager || '',
            tin: branch.tin || '',
            owner_is_manager: !!branch.branch_owner && branch.branch_owner === branch.manager,
            facebook_url: branch.facebook_url || '',
            phone_number: branch.phone_number || '',
            telephone_number: branch.telephone_number || '',
        })
        setNewDocFilesByCategory({})
        // fetchBranchDocuments(branch.branch_id) // disabled: branch document upload feature
        setShowEditModal(true)
    }

    const handleUpdateBranch = async () => {
        if (!editingBranch) return
        const { name, address, open_time, close_time, operating_start_date, branch_owner, email, status } = branchFormData
        if (!name.trim() || !address.trim() || !open_time || !close_time || !operating_start_date || !branch_owner.trim() || !email.trim() || !status) {
            Swal.fire({ icon: 'warning', title: 'Missing Information', text: 'Please fill in all required fields.' })
            return
        }
        if (branchFormData.business_email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(branchFormData.business_email.trim())) {
            Swal.fire({ icon: 'warning', title: 'Invalid Business Email', text: 'Please enter a valid business email address.' })
            return
        }
        try {
            const { error } = await supabase.from('branches')
            .update({
                name: name.trim(),
                address: address.trim(),
                open_time,
                close_time,
                operating_start_date,
                status: branchFormData.status,
                branch_owner: branchFormData.branch_owner.trim() || null,
                email: branchFormData.email.trim() || null,
                business_email: branchFormData.business_email.trim() || null,
                manager: branchFormData.owner_is_manager
                    ? branchFormData.branch_owner.trim() || null
                    : branchFormData.manager.trim() || null,
                tin: branchFormData.tin.trim() || null,
                facebook_url: branchFormData.facebook_url.trim() || null,
                phone_number: branchFormData.phone_number.trim() || null,
                telephone_number: branchFormData.telephone_number.trim() || null,
            })
            .eq('branch_id', editingBranch.branch_id)

        if (error) throw error

        /* --- Branch document upload (image/PDF) temporarily disabled ---
        for (const [category, files] of Object.entries(newDocFilesByCategory)) {
            for (const file of files) {
                await uploadBranchDocument(file, editingBranch.branch_id, category)
            }
        }
        --- end disabled block --- */

            setShowEditModal(false);
            setEditingBranch(null);
            resetBranchForm();
            fetchBranches()

            Swal.fire({
                icon: 'success',
                title: 'Branch Updated',
                timer: 1800,
                showConfirmButton: false
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Update Branch',
                text: err.message
            })
        }
    }

    /* --- Branch document upload/fetch/delete (image/PDF) temporarily disabled ---
    const uploadBranchDocument = async (file, branchId, category) => {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png']
        if (!allowedTypes.includes(file.type)) throw new Error('Only PDF, JPG, JPEG, and PNG files are allowed.')
        if (file.size > 10 * 1024 * 1024) throw new Error('File size must not exceed 10MB.')

        const fileExt = file.name.split('.').pop()
        const fileName = `${branchId}/${category}/${Date.now()}-${Math.random().toString(36).slice(2)}.${fileExt}`

        const { error: uploadError } = await supabase.storage
            .from('branch_docu')
            .upload(fileName, file, { cacheControl: '3600', upsert: false })
        if (uploadError) throw uploadError

        const { data } = supabase.storage.from('branch_docu').getPublicUrl(fileName)

        const { error: insertErr } = await supabase.from('branch_documents').insert([{
            branch_id: branchId,
            file_name: file.name,
            file_url: data.publicUrl,
            file_type: file.type,
            doc_category: category,
        }])
        if (insertErr) throw insertErr
    }

    const fetchBranchDocuments = async (branchId) => {
        try {
            setLoadingBranchDocs(true)
            const { data, error } = await supabase
                .from('branch_documents')
                .select('*')
                .eq('branch_id', branchId)
                .order('uploaded_at', { ascending: false })
            if (error) throw error
            setBranchDocuments(data || [])
        } catch (err) {
            console.error('Error fetching branch documents:', err)
        } finally {
            setLoadingBranchDocs(false)
        }
    }

    const handleDeleteBranchDocument = async (documentId) => {
        const result = await Swal.fire({
            icon: 'warning', title: 'Remove Document?',
            showCancelButton: true, confirmButtonText: 'Remove', confirmButtonColor: '#8B5A3C'
        })
        if (!result.isConfirmed) return
        try {
            const { error } = await supabase.from('branch_documents').delete().eq('document_id', documentId)
            if (error) throw error
            setBranchDocuments(prev => prev.filter(d => d.document_id !== documentId))
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Remove Document', text: err.message })
        }
    }
    --- end disabled block --- */

    // Archive
    const handleArchiveBranch = async (branch) => {
        const result = await Swal.fire({
            icon: 'warning',
            title: 'Archive Branch?',
            text: `"${branch.name}" will be set to inactive and hidden from active branch lists.`,
            showCancelButton: true,
            confirmButtonText: 'Archive',
            confirmButtonColor: '#8B5A3C'
        })

        if (!result.isConfirmed) return
        
        try {
            const { error } = await supabase.from('branches')
                .update({ status: 'inactive' })
                .eq('branch_id', branch.branch_id)

            if (error) throw error

            fetchBranches()

            Swal.fire({
                icon: 'success',
                title: 'Branch Archived',
                timer: 1500,
                showConfirmButton: false
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Archive Branch',
                text: err.message
            })
        }
    }

    // Reinstate
    const handleReinstateBranch = async (branch) => {
        const result = await Swal.fire({
            title: 'Reinstate Branch?',
            text: `"${branch.name}" will be set back to operating.`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#16a34a',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, reinstate',
            cancelButtonText: 'Cancel'
        })

        if (!result.isConfirmed) return

        try {
            const { error } = await supabase.from('branches')
                .update({ status: 'operating' })
                .eq('branch_id', branch.branch_id)

            if (error) throw error

            fetchBranches()
            fetchArchivedBranches()

            Swal.fire({
                icon: 'success',
                title: 'Branch Reinstated',
                timer: 1500,
                showConfirmButton: false
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Reinstate Branch',
                text: err.message
            })
        }
    }

    // Branch filtering
    const STATUS_FILTER_OPTIONS = [
        { key: 'all', label: 'All Statuses' },
        { key: 'operating', label: 'Operating' },
        { key: 'closed', label: 'Closed' },
        { key: 'maintenance', label: 'Maintenance' },
        { key: 'inactive', label: 'Inactive' },
    ]

    const filteredBranches = branches.filter(branch => {
        const matchesSearch =
            branch.name?.toLowerCase().includes(branchSearch.toLowerCase()) ||
            branch.address?.toLowerCase().includes(branchSearch.toLowerCase())
        const matchesStatus = branchStatusFilter === 'all' || branch.status === branchStatusFilter
        return matchesSearch && matchesStatus
    })

    const pagedBranches = filteredBranches.slice((branchPage - 1) * BRANCH_PAGE_SIZE, branchPage * BRANCH_PAGE_SIZE)

    // Banner fetch
    const fetchBanners = async () => {
        try {
            setBannersLoading(true)
            const res = await fetch(`${BASE_URL}/api/hero-banners`, { headers: authHeaders() })
            if (!res.ok) throw new Error('Failed to load banners')
            setBanners(await res.json())
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Load Banners', text: err.message, confirmButtonColor: '#8B5A3C' })
        } finally {
            setBannersLoading(false)
        }
    }

    const fetchArchivedBanners = async () => {
        try {
            const res = await fetch(`${BASE_URL}/api/hero-banners/archived`, { headers: authHeaders() })
            if (!res.ok) throw new Error('Failed to load archived banners')
            setArchivedBanners(await res.json())
        } catch (err) {
            console.error('Error fetching archived banners:', err)
        }
    }

    const fetchPromotions = async () => {
        try {
            const res = await fetch(`${BASE_URL}/api/hero-banners/promotions`, { headers: authHeaders() })
            if (!res.ok) throw new Error('Failed to load promotions')
            setPromotions(await res.json())
        } catch (err) {
            console.error('Error fetching promotions:', err)
        }
    }

    // Banner branch helpers
    const areAllBranchesSelected  = activeBranches.length > 0 && selectedBranchIds.size === activeBranches.length
    const toggleBranch = (id) => setSelectedBranchIds(prev => {
        const next = new Set(prev)
        next.has(id) ? next.delete(id) : next.add(id)
        return next
    })
    const handleToggleAll = () =>
        setSelectedBranchIds(areAllBranchesSelected ? new Set() : new Set(activeBranches.map(b => b.branch_id)))

    // Branch form change detection
    const normalizeBranchFormData = (d = {}) => ({
        name: String(d.name || '').trim(),
        address: String(d.address || '').trim(),
        open_time: String(d.open_time || '').trim(),
        close_time: String(d.close_time || '').trim(),
        operating_start_date: String(d.operating_start_date || '').trim(),
        status: String(d.status || 'operating').trim(),
        branch_owner: String(d.branch_owner || '').trim(),
        email: String(d.email || '').trim(),
        business_email: String(d.business_email || '').trim(),
        manager: String(d.manager || '').trim(),
        tin: String(d.tin || '').trim(),
        owner_is_manager: !!d.owner_is_manager,
        facebook_url: String(d.facebook_url || '').trim(),
        phone_number: String(d.phone_number || '').trim(),
        telephone_number: String(d.telephone_number || '').trim(),
    })

    const hasStagedDocFiles = Object.values(newDocFilesByCategory).some(files => (files || []).length > 0)

    const hasAddBranchChanges =
        JSON.stringify(normalizeBranchFormData(branchFormData)) !==
            JSON.stringify(normalizeBranchFormData(EMPTY_BRANCH_FORM)) ||
        hasStagedDocFiles

    const hasEditBranchChanges =
        initialBranchFormData !== null &&
        (
            JSON.stringify(normalizeBranchFormData(branchFormData)) !==
                JSON.stringify(normalizeBranchFormData(initialBranchFormData)) ||
            hasStagedDocFiles
        )

    // Banner change detection
    const normalizeBannerForm = (d = {}) => ({
        title: String(d.title || '').trim(),
        subtitle: String(d.subtitle || '').trim(),
        image_url: String(d.image_url || '').trim(),
        start_at: String(d.start_at || '').trim(),
        end_at: String(d.end_at || '').trim(),
        is_active: !!d.is_active,
        availability: String(d.availability || 'permanent').trim(),
        linked_promotion_id: String(d.linked_promotion_id || '').trim(),
    })

    const hasAddBannerChanges =
        JSON.stringify(normalizeBannerForm(bannerFormData)) !==
        JSON.stringify(normalizeBannerForm(EMPTY_BANNER)) ||
        bannerImageFile !== null

    const hasEditBannerChanges =
        initialBannerFormData !== null && (
            JSON.stringify(normalizeBannerForm(bannerFormData)) !==
            JSON.stringify(normalizeBannerForm(initialBannerFormData)) ||
            !areSetsEqual(selectedBranchIds, initialSelectedBranchIds) ||
            bannerImageFile !== null
        )

    // Banner validation
    const validateBannerForm = () => {
        if (!bannerFormData.title.trim()) {
            Swal.fire({ icon: 'warning', title: 'Missing Title', text: 'Banner title is required.', confirmButtonColor: '#8B5A3C' })
            return false
        }
        if (bannerImageMode === 'url' && !bannerFormData.image_url.trim()) {
            Swal.fire({ icon: 'warning', title: 'Missing Image', text: 'Please enter an image URL.', confirmButtonColor: '#8B5A3C' })
            return false
        }
        if (bannerImageMode === 'upload' && !bannerImageFile && !bannerFormData.image_url) {
            Swal.fire({ icon: 'warning', title: 'Missing Image', text: 'Please upload an image.', confirmButtonColor: '#8B5A3C' })
            return false
        }
        if (bannerFormData.availability === 'limited') {
            if (!bannerFormData.start_at || !bannerFormData.end_at) {
                Swal.fire({ icon: 'warning', title: 'Missing Dates', text: 'Limited time banners require both a start and end date.', confirmButtonColor: '#8B5A3C' })
                return false
            }
            if (new Date(bannerFormData.end_at) < new Date(bannerFormData.start_at)) {
                Swal.fire({ icon: 'warning', title: 'Invalid Date Range', text: 'End date must be after or equal to start date.', confirmButtonColor: '#8B5A3C' })
                return false
            }
        }
        return true
    }

    // Banner open modals
    const resetBannerForm = () => {
        setBannerFormData(EMPTY_BANNER)
        setSelectedBranchIds(new Set())
        setInitialSelectedBranchIds(new Set())
        setInitialBannerFormData(null)
        setBannerImageFile(null)
        setBannerImageMode('upload')
    }

    const openAddBannerModal = () => {
        resetBannerForm()
        setEditingBanner(null)
        setShowAddBannerModal(true)
    }

    const openEditBannerModal = async (banner) => {
        setShowAddBannerModal(false)

        const normalized = {
            title: banner.title || '',
            subtitle: banner.subtitle  || '',
            image_url: banner.image_url || '',
            link_url: banner.link_url  || '',
            start_at: banner.start_at  || '',
            end_at: banner.end_at    || '',
            is_active: banner.is_active ?? true,
            availability: (banner.start_at || banner.end_at) ? 'limited' : 'permanent',
            linked_promotion_id: banner.linked_promotion_id || '',
        }
        setBannerImageFile(null)

        const isStorageUrl = banner.image_url?.includes('/storage/v1/object/public/hero_banners/')
            setBannerImageMode(banner.image_url && !isStorageUrl ? 'url' : 'upload')
        
            setEditingBanner(banner)
        setBannerFormData(normalized)
        setInitialBannerFormData(normalized)

        try {
            // NEW: fetch branch associations via backend API instead of direct Supabase query
            const res = await fetch(`${BASE_URL}/api/hero-banners/${banner.banner_id}/branches`, { headers: authHeaders() })
            if (!res.ok) throw new Error('Failed to load banner branches')
            const branchIds = await res.json()
            const branchSet = new Set(branchIds)

            setSelectedBranchIds(branchSet)
            setInitialSelectedBranchIds(new Set(branchSet))
            setShowEditBannerModal(true)

        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Load Banner Branches',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    // Banner CRUD
    const handleAddBanner = async () => {
        if (!validateBannerForm()) return
        try {
            const n = normalizeBannerForm(bannerFormData)
            let finalImageUrl = n.image_url || null
            if (bannerImageMode === 'upload' && bannerImageFile) {
                finalImageUrl = await uploadBannerImage(bannerImageFile)
            }
            const res = await fetch(`${BASE_URL}/api/hero-banners`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    title: n.title,
                    subtitle: n.subtitle || null,
                    image_url: finalImageUrl,
                    link_url: n.link_url || null,
                    start_at: n.availability === 'limited' ? n.start_at || null : null,
                    end_at: n.availability === 'limited' ? n.end_at || null : null,
                    is_active: n.is_active,
                    linked_promotion_id: n.linked_promotion_id || null,
                    branch_ids: Array.from(selectedBranchIds),
                }),
            })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error || 'Failed to add banner')

            await fetchBanners()
            setShowAddBannerModal(false)
            resetBannerForm()
            Swal.fire({ icon: 'success', title: 'Banner Added!', text: `"${data.title}" has been added.`, confirmButtonColor: '#8B5A3C', timer: 1800 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Add Banner', text: err.message, confirmButtonColor: '#8B5A3C' })
        }
    }

    const uploadBannerImage = async (file) => {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp']
        if (!allowedTypes.includes(file.type)) throw new Error('Only JPG, PNG, and WEBP images are allowed.')
        if (file.size > 5 * 1024 * 1024) throw new Error('Image size must not exceed 5MB.')
        const fileExt = file.name.split('.').pop()
        const fileName = `${Date.now()}-${Math.random().toString(36).slice(2)}.${fileExt}`
        const { error: uploadError } = await supabase.storage.from('hero_banners').upload(fileName, file, { cacheControl: '3600', upsert: false })
        if (uploadError) throw uploadError
        const { data } = supabase.storage.from('hero_banners').getPublicUrl(fileName)
        return data.publicUrl
    }

    const handleUpdateBanner = async () => {
        if (!editingBanner || !hasEditBannerChanges) return
        if (!validateBannerForm()) return
        try {
            const n = normalizeBannerForm(bannerFormData)
            let finalImageUrl = n.image_url || null
            if (bannerImageMode === 'upload' && bannerImageFile) {
                finalImageUrl = await uploadBannerImage(bannerImageFile)
            }
            const res = await fetch(`${BASE_URL}/api/hero-banners/${editingBanner.banner_id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    title: n.title,
                    subtitle: n.subtitle || null,
                    image_url: finalImageUrl,
                    link_url: n.link_url || null,
                    start_at: n.availability === 'limited' ? n.start_at || null : null,
                    end_at: n.availability === 'limited' ? n.end_at || null : null,
                    is_active: n.is_active,
                    linked_promotion_id: n.linked_promotion_id || null,
                    branch_ids: Array.from(selectedBranchIds),
                }),
            })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error || 'Failed to update banner')

            await fetchBanners()
            setShowEditBannerModal(false)
            setEditingBanner(null)
            resetBannerForm()
            Swal.fire({ icon: 'success', title: 'Banner Updated!', text: `"${data.title}" has been updated.`, confirmButtonColor: '#8B5A3C', timer: 1800 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Update Banner', text: err.message, confirmButtonColor: '#8B5A3C' })
        }
    }

    const handleArchiveBanner = async (bannerId) => {
        const result = await Swal.fire({ icon: 'warning', title: 'Archive Banner', text: 'This banner will be hidden from all branches.', showCancelButton: true, confirmButtonText: 'Archive', confirmButtonColor: '#8B5A3C' })
        if (!result.isConfirmed) return
        try {
            const res = await fetch(`${BASE_URL}/api/hero-banners/${bannerId}/archive`, { method: 'PATCH', headers: authHeaders() })
            if (!res.ok) throw new Error((await res.json()).error || 'Failed to archive banner')
            await fetchBanners()
            await fetchArchivedBanners()
            Swal.fire({ icon: 'success', title: 'Banner Archived', confirmButtonColor: '#8B5A3C', timer: 1500 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Archive Banner', text: err.message, confirmButtonColor: '#8B5A3C' })
        }
    }

    
    const handleReinstateBanner = async (bannerId) => {
        try {
            const res = await fetch(`${BASE_URL}/api/hero-banners/${bannerId}/reinstate`, { method: 'PATCH', headers: authHeaders() })
            if (!res.ok) throw new Error((await res.json()).error || 'Failed to reinstate banner')
            await fetchBanners()
            await fetchArchivedBanners()
            Swal.fire({ icon: 'success', title: 'Banner Restored', confirmButtonColor: '#8B5A3C', timer: 1500 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Reinstate Banner', text: err.message, confirmButtonColor: '#8B5A3C' })
        }
    }

    // Archived banner viewer modal handlers
    const openArchivedBannersModal = async () => {
        setShowArchivedBannersModal(true)
        setArchivedBannerSearch('')
        setLoadingArchivedBanners(true)
        try {
            await fetchArchivedBanners()
        } catch (err) {
            console.error('Error fetching archived banners:', err)
        } finally {
            setLoadingArchivedBanners(false)
        }
    }

    const openArchivedBranchesModal = async () => {
        setShowArchivedBranchesModal(true)
        setArchivedBranchSearch('')
        await fetchArchivedBranches()
    }

    // Banner filtering (active)
    const filteredBanners = banners.filter(banner =>
        banner.title?.toLowerCase().includes(bannerSearch.toLowerCase()) ||
        banner.subtitle?.toLowerCase().includes(bannerSearch.toLowerCase())
    )

    const filteredArchivedBanners = archivedBanners.filter(banner =>
        banner.title?.toLowerCase().includes(archivedBannerSearch.toLowerCase()) ||
        banner.subtitle?.toLowerCase().includes(archivedBannerSearch.toLowerCase())
    )

    const pagedArchivedBanners = filteredArchivedBanners.slice((archivedBannerPage - 1) * ARCHIVE_PAGE_SIZE, archivedBannerPage * ARCHIVE_PAGE_SIZE)
    const filteredArchivedBranches = archivedBranches.filter(branch =>
        branch.name?.toLowerCase().includes(archivedBranchSearch.toLowerCase()) ||
        branch.address?.toLowerCase().includes(archivedBranchSearch.toLowerCase())
    )
    const pagedArchivedBranches = filteredArchivedBranches.slice((archivedBranchPage - 1) * ARCHIVE_PAGE_SIZE, archivedBranchPage * ARCHIVE_PAGE_SIZE)
    const pagedFilteredBanners = filteredBanners.slice((bannerPage - 1) * BANNER_PAGE_SIZE, bannerPage * BANNER_PAGE_SIZE)

    // Formatting helpers
    const formatTime = (v) => {
        if (!v) return '-'
        const [hours, minutes] = v.split(':')
        let h = parseInt(hours, 10)
        const suffix = h >= 12 ? 'PM' : 'AM'
        h = h % 12 || 12
        return `${h}:${minutes} ${suffix}`
    }
    const formatDate = (v) => v
        ? new Date(v).toLocaleDateString('en-PH', { year: 'numeric', month: 'short', day: 'numeric' })
        : '-'
    const formatBannerDate = (v) => v
        ? new Date(v).toLocaleDateString('en-PH', { month: 'short', day: 'numeric', year: 'numeric' })
        : null
 
    const getStatusColor = (status) => {
        switch (status) {
            case 'operating':   return 'bg-green-100 text-green-800'
            case 'closed':      return 'bg-gray-100 text-gray-800'
            case 'maintenance': return 'bg-yellow-100 text-yellow-800'
            case 'inactive':    return 'bg-red-100 text-red-800'
            default:            return 'bg-gray-100 text-gray-800'
        }
    }
 
    const closeBranchModal = () => {
        setShowAddModal(false);
        setShowEditModal(false)
        setEditingBranch(null);
        resetBranchForm()
        setInitialBranchFormData(null)
    }
    
    const groupedBranchDocuments = DOCUMENT_CATEGORIES.reduce((acc, cat) => {
        acc[cat.key] = branchDocuments.filter(d => d.doc_category === cat.key)
        return acc
    }, {})

    // Branch selector (for banner form)
    const renderBranchSelector = () => (
        <div>
            <div className="flex items-center justify-between mb-2">
                <label className="text-sm font-medium text-gray-700">
                    Branch Availability
                </label>
                <button type="button" onClick={handleToggleAll}
                    className="text-sm font-medium text-[#8B5A3C] hover:underline">
                    {areAllBranchesSelected ? 'Clear All' : 'Select All'}
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {activeBranches.length === 0 ? (
                    <p className="text-sm text-gray-500 border border-gray-200 rounded-lg px-3 py-2">
                        No active branches available.
                    </p>
                ) : (
                    activeBranches.map((branch) => {
                        const isChecked = selectedBranchIds.has(branch.branch_id)
                        return (
                            <label key={branch.branch_id}
                                className={`flex items-center gap-3 px-3 py-2 rounded-lg border cursor-pointer transition-colors ${
                                    isChecked ? 'bg-[#F3EAE4] border-[#8B5A3C]' : 'bg-white border-gray-200 hover:bg-gray-50'
                                }`}>
                                <input type="checkbox" checked={isChecked}
                                    onChange={() => toggleBranch(branch.branch_id)}
                                    className="w-4 h-4 accent-[#8B5A3C] cursor-pointer" />
                                <span className={`text-sm font-medium ${isChecked ? 'text-[#8B5A3C]' : 'text-gray-700'}`}>
                                    {branch.name}
                                </span>
                            </label>
                        )
                    })
                )}
            </div>
            <p className="text-xs text-gray-500 mt-2">
                {selectedBranchIds.size === 0
                    ? 'No branches selected — banner won\'t show anywhere'
                    : `Showing on ${selectedBranchIds.size} branch${selectedBranchIds.size !== 1 ? 'es' : ''}`}
            </p>
        </div>
    )

    // Promotion Picker
    const filteredPromotionOptions = promotions.filter((p) =>
        !promotionSearch ||
        p.promotion_name.toLowerCase().includes(promotionSearch.toLowerCase())
    )

    const renderPromotionPicker = () => {
        const selectedPromotion = promotions.find((p) => p.promotion_id === bannerFormData.linked_promotion_id)

        return (
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Linked Promotion <span className="text-xs text-gray-500">(optional — banner will link customers to this promotion)</span>
                </label>

                {selectedPromotion ? (
                    <div className="flex items-center justify-between px-3 py-2 border border-[#8B5A3C] bg-[#F3EAE4] rounded-lg">
                        <div>
                            <p className="text-sm font-medium text-[#8B5A3C]">{selectedPromotion.promotion_name}</p>
                            <p className="text-xs text-gray-500 capitalize">{selectedPromotion.promotion_type} · {selectedPromotion.status}</p>
                        </div>
                        <button
                            type="button"
                            onClick={() => setBannerFormData({ ...bannerFormData, linked_promotion_id: '' })}
                            className="text-sm font-medium text-red-600 hover:underline"
                        >
                            Remove
                        </button>
                    </div>
                ) : (
                    <div className="space-y-2">
                        <input
                            type="text"
                            value={promotionSearch}
                            onChange={(e) => setPromotionSearch(e.target.value)}
                            placeholder="Search promotions by name..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                        />
                        <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg divide-y divide-gray-100">
                            {filteredPromotionOptions.length === 0 ? (
                                <div className="px-3 py-3 text-sm text-gray-500">No promotions found.</div>
                            ) : (
                                filteredPromotionOptions
                                    .slice((promotionPickerPage - 1) * PROMOTION_PAGE_SIZE, promotionPickerPage * PROMOTION_PAGE_SIZE)
                                    .map((p) => (
                                        <button
                                            key={p.promotion_id}
                                            type="button"
                                            onClick={() => {
                                                setBannerFormData({ ...bannerFormData, linked_promotion_id: p.promotion_id })
                                                setPromotionSearch('')
                                            }}
                                            className="w-full text-left px-3 py-2 hover:bg-gray-50"
                                        >
                                            <p className="text-sm font-medium text-gray-800">{p.promotion_name}</p>
                                            <p className="text-xs text-gray-500 capitalize">{p.promotion_type} · {p.status}</p>
                                        </button>
                                    ))
                            )}
                        </div>
                        {filteredPromotionOptions.length > PROMOTION_PAGE_SIZE && (
                            <Pagination
                                page={promotionPickerPage}
                                totalItems={filteredPromotionOptions.length}
                                pageSize={PROMOTION_PAGE_SIZE}
                                onPageChange={setPromotionPickerPage}
                            />
                        )}
                    </div>
                )}
            </div>
        )
    }
 
    // Banner Form body (Add & Edit)
    const renderBannerFormBody = () => (
        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
            {/* Title */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Title <span className="text-red-500">*</span>
                </label>
                <input type="text" value={bannerFormData.title}
                    onChange={(e) => setBannerFormData({ ...bannerFormData, title: e.target.value })}
                    maxLength={MAX.title} placeholder="Enter banner title"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                <p className="text-xs text-gray-500 mt-1">{bannerFormData.title.length}/{MAX.title} characters</p>
            </div>
 
            {/* Subtitle */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Subtitle / Description</label>
                <textarea value={bannerFormData.subtitle}
                    onChange={(e) => setBannerFormData({ ...bannerFormData, subtitle: e.target.value })}
                    rows={3} maxLength={MAX.subtitle} placeholder="Optional tagline or short description"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                <p className="text-xs text-gray-500 mt-1">{bannerFormData.subtitle.length}/{MAX.subtitle} characters</p>
            </div>
 
            {/* Image */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Banner Image <span className="text-red-500">*</span>
                </label>
                <div className="inline-flex mb-3 rounded-lg bg-gray-100 p-1">
                    <button type="button"
                        onClick={() => { setBannerImageMode('upload'); setBannerFormData({ ...bannerFormData, image_url: '' }) }}
                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${bannerImageMode === 'upload' ? 'bg-[#8B5A3C] text-white shadow-sm' : 'bg-transparent text-gray-600 hover:text-gray-800'}`}>
                        Upload Image
                    </button>
                    <button type="button"
                        onClick={() => { setBannerImageMode('url'); setBannerImageFile(null) }}
                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${bannerImageMode === 'url' ? 'bg-[#8B5A3C] text-white shadow-sm' : 'bg-transparent text-gray-600 hover:text-gray-800'}`}>
                        Use Image URL
                    </button>
                </div>
                {bannerImageMode === 'upload' ? (
                    <div className="space-y-2">
                        <input type="file" accept="image/png,image/jpeg,image/webp"
                            onChange={(e) => setBannerImageFile(e.target.files?.[0] || null)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                        <p className="text-xs text-gray-500">Accepted: JPG, PNG, WEBP. Max size: 5MB.</p>
                        {!bannerImageFile && bannerFormData.image_url && (
                            <div className="mt-2 rounded-lg overflow-hidden border border-gray-200 h-28 bg-gray-100">
                                <img src={bannerFormData.image_url} alt="Current banner"
                                    className="h-full w-full object-cover" />
                                <p className="text-xs text-gray-400 text-center py-1">Current image — upload a new one to replace</p>
                            </div>
                        )}                    </div>
                ) : (
                    <div>
                        <input type="url" value={bannerFormData.image_url}
                            onChange={(e) => setBannerFormData({ ...bannerFormData, image_url: e.target.value })}
                            placeholder="https://..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                        {bannerFormData.image_url && (
                            <div className="mt-2 rounded-lg overflow-hidden border border-gray-200 h-28 bg-gray-100">
                                <img src={bannerFormData.image_url} alt="Preview"
                                    className="h-full w-full object-cover"
                                    onError={(e) => { e.target.style.display = 'none' }} />
                            </div>
                        )}
                    </div>
                )}
            </div>

 
            {/* Availability */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Availability</label>
                <div className="inline-flex rounded-lg bg-gray-100 p-1">
                    <button type="button"
                        onClick={() => setBannerFormData({ ...bannerFormData, availability: 'permanent', start_at: '', end_at: '' })}
                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${bannerFormData.availability === 'permanent' ? 'bg-[#8B5A3C] text-white shadow-sm' : 'bg-transparent text-gray-600 hover:text-gray-800'}`}>
                        Permanent
                    </button>
                    <button type="button"
                        onClick={() => setBannerFormData({ ...bannerFormData, availability: 'limited' })}
                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${bannerFormData.availability === 'limited' ? 'bg-[#8B5A3C] text-white shadow-sm' : 'bg-transparent text-gray-600 hover:text-gray-800'}`}>
                        Limited Time
                    </button>
                </div>
                {bannerFormData.availability === 'limited' && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Start Date <span className="text-red-500">*</span></label>
                            <input type="date" value={bannerFormData.start_at}
                                onChange={(e) => setBannerFormData({ ...bannerFormData, start_at: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">End Date <span className="text-red-500">*</span></label>
                            <input type="date" value={bannerFormData.end_at}
                                onChange={(e) => setBannerFormData({ ...bannerFormData, end_at: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                        </div>
                    </div>
                )}
            </div>
 
            {/* Status */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Status <span className="text-red-500">*</span></label>
                <select value={bannerFormData.is_active ? 'active' : 'inactive'}
                    onChange={(e) => setBannerFormData({ ...bannerFormData, is_active: e.target.value === 'active' })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                </select>
            </div>
 
            {renderPromotionPicker()}

            {renderBranchSelector()}
        </div>
    )
 
    // ─── Pagination  ─────────────────────────────────────────────
    function Pagination({ page, totalItems, pageSize, onPageChange }) {
        const totalPages = Math.ceil(totalItems / pageSize)
        if (totalItems === 0) return null

        return (
            <div className="flex items-center justify-between px-4 py-2 rounded-b-xl"
                >
                <span style={{ fontSize: 14, color: C.midgrey }}>
                    Showing <span className="font-medium text-gray-700">{Math.min((page - 1) * pageSize + 1, totalItems)}–{Math.min(page * pageSize, totalItems)}</span> of <span className="font-medium text-gray-700">{totalItems}</span> items
                </span>
                {totalPages > 1 && (
                    <div className="flex items-center gap-1">
                        <button
                            onClick={() => onPageChange(Math.max(1, page - 1))}
                            disabled={page === 1}
                            style={{
                                padding: "3px 10px", borderRadius: 8,
                                border: `1px solid ${C.border}`, background: C.card,
                                color: page === 1 ? C.border : C.textSoft,
                                fontSize: 14, cursor: page === 1 ? "not-allowed" : "pointer",
                            }}>
                            ← Prev
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(n => n === 1 || n === totalPages || Math.abs(n - page) <= 1)
                            .reduce((acc, n, idx, arr) => {
                                if (idx > 0 && n - arr[idx - 1] > 1) acc.push("…")
                                acc.push(n)
                                return acc
                            }, [])
                            .map((n, idx) =>
                                n === "…" ? (
                                    <span key={`e-${idx}`} style={{ fontSize: 16, color: C.midgrey, padding: "0 2px" }}>…</span>
                                ) : (
                                    <button key={n} onClick={() => onPageChange(n)}
                                        style={{
                                            width: 28, height: 28, borderRadius: 8,
                                            border: `1px solid ${n === page ? C.nude : C.border}`,
                                            background: n === page ? C.nude : C.card,
                                            color: n === page ? "#fff" : C.textSoft,
                                            fontSize: 14, fontWeight: n === page ? 600 : 400,
                                            cursor: "pointer",
                                        }}>
                                        {n}
                                    </button>
                                )
                            )
                        }
                        <button
                            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
                            disabled={page === totalPages}
                            style={{
                                padding: "3px 10px", borderRadius: 8,
                                border: `1px solid ${C.border}`, background: C.card,
                                color: page === totalPages ? C.border : C.textSoft,
                                fontSize: 14, cursor: page === totalPages ? "not-allowed" : "pointer",
                            }}>
                            Next →
                        </button>
                    </div>
                )}
            </div>
        )
    }

    // Render
    return (
        <div className="flex-1 overflow-y-auto bg-gray-50">
            <Header title="Branch Management" subtitle="Manage branch information and monitor multi-branch overview"  onGoToProfile={onGoToProfile}/>
 
            <div className="p-8">
                {/* Tabs */}
                <div className="flex gap-4 mb-6">
                    <div className="flex gap-2 flex-wrap">
                        {[{ key: 'branches', label: 'Branches' }, { key: 'banners', label: 'Hero Banners' }].map((tab) => (
                            <button key={tab.key} onClick={() => setActiveTab(tab.key)}
                                className={`px-5 py-2.5 rounded-lg font-medium transition-colors ${
                                    activeTab === tab.key
                                        ? 'bg-[#8B5A3C] text-white'
                                        : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
                                }`}>
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>
 
                {/* Branches Tab */}
                {activeTab === 'branches' && (
                    <>
                        {/* Toolbar */}
                        <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
                            {/* Left: search + status filter */}
                            <div className="flex flex-wrap items-center gap-3">
                                {/* Search */}
                                <div className="relative">
                                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"/>
                                        </svg>
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Search branches..."
                                        value={branchSearch}
                                        onChange={(e) => setBranchSearch(e.target.value)}
                                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] w-full sm:w-56"
                                    />
                                </div>
 
                                {/* Status filter dropdown */}
                                <div className="relative" id="branch-status-dropdown-wrapper">
                                    <button
                                        onClick={() => setBranchStatusDropdownOpen(v => !v)}
                                        className="flex items-center gap-2 px-4 py-2 border border-gray-300 bg-white rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        {STATUS_FILTER_OPTIONS.find(o => o.key === branchStatusFilter)?.label ?? 'All Statuses'}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                            className={`text-gray-400 transition-transform duration-150 ${branchStatusDropdownOpen ? 'rotate-180' : ''}`}>
                                            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m6 9 6 6 6-6"/>
                                        </svg>
                                    </button>
 
                                    {branchStatusDropdownOpen && (
                                        <div className="absolute left-0 mt-1 w-44 bg-white border border-gray-200 rounded-lg shadow-lg z-20">
                                            {STATUS_FILTER_OPTIONS.map(opt => (
                                                <button
                                                    key={opt.key}
                                                    onClick={() => { setBranchStatusFilter(opt.key); setBranchStatusDropdownOpen(false) }}
                                                    className={`w-full text-left px-4 py-2 text-sm transition-colors first:rounded-t-lg last:rounded-b-lg ${
                                                        branchStatusFilter === opt.key
                                                            ? 'bg-[#F3EAE4] text-[#8B5A3C] font-medium'
                                                            : 'text-gray-700 hover:bg-gray-50'
                                                    }`}
                                                >
                                                    {opt.label}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
 
                                {/* Result count */}
                                {(branchSearch || branchStatusFilter !== 'all') && (
                                    <span className="text-sm text-gray-500">
                                        {filteredBranches.length} result{filteredBranches.length !== 1 ? 's' : ''}
                                    </span>
                                )}
                            </div>
 
                            {/* Right: archived viewer + add */}
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={openArchivedBranchesModal}
                                    className="p-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg"
                                    title="View Archived Branches"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 6v10h12V9zm2 2h8v2H8zm0 4h8v2H8zM5 5v2h14V5z"/>
                                    </svg>
                                </button>
                                <button
                                    onClick={() => { resetBranchForm(); setShowAddModal(true) }}
                                    className="px-4 py-2 bg-[#8B5A3C] text-white rounded-lg font-medium hover:bg-[#6d4730] transition-colors"
                                >
                                    + Add Branch
                                </button>
                            </div>
                        </div>                        
 
                        {/* Branch Cards */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                            {loading ? (
                                Array.from({ length: 6 }).map((_, i) => (
                                    <div key={i} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                                        <div className="px-5 pt-5 pb-4">
                                            <div className="flex items-start justify-between gap-3">
                                                <div className="flex items-center gap-3 min-w-0 flex-1">
                                                    <SkeletonBlock className="w-11 h-11 rounded-lg flex-shrink-0" />
                                                    <div className="min-w-0 flex-1 space-y-2">
                                                        <SkeletonBlock className="h-4 w-3/4" />
                                                        <SkeletonBlock className="h-3 w-1/2" />
                                                    </div>
                                                </div>
                                                <SkeletonBlock className="w-16 h-5 rounded-full flex-shrink-0" />
                                            </div>
                                        </div>
                                        <div className="mx-5 border-t border-gray-100" />
                                        <div className="px-5 py-4 space-y-3">
                                            <SkeletonBlock className="h-3 w-2/3" />
                                            <SkeletonBlock className="h-3 w-full" />
                                            <SkeletonBlock className="h-3 w-1/2" />
                                        </div>
                                        <div className="px-5 pb-5 flex gap-2">
                                            <SkeletonBlock className="flex-1 h-9 rounded-lg" />
                                            <SkeletonBlock className="flex-1 h-9 rounded-lg" />
                                        </div>
                                    </div>
                                ))
                            ) : filteredBranches.length === 0 ? (
                                <div className="col-span-3 bg-white rounded-lg shadow-sm p-8 text-center text-gray-500">
                                    {branches.length === 0 ? 'No branches found.' : 'No branches match your search.'}
                                </div>
                            ) : (
                                pagedBranches.map((branch) => (
                                    <div key={branch.branch_id} className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-gray-300 transition-all duration-200 overflow-hidden">
                                        {/* Card header — colored accent bar + identity */}
                                        <div className="px-5 pt-5 pb-4">
                                            <div className="flex items-start justify-between gap-3">
                                                <div className="flex items-center gap-3 min-w-0">
                                                    <div className="w-11 h-11 bg-[#8B5A3C] rounded-lg flex-shrink-0 flex items-center justify-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                                                            <path fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 12c.263 0 .524-.06.767-.175a2 2 0 0 0 .65-.491c.186-.21.333-.46.433-.734s.15-.568.15-.864a2.4 2.4 0 0 0 .586 1.591c.375.422.884.659 1.414.659s1.04-.237 1.414-.659A2.4 2.4 0 0 0 12 9.736a2.4 2.4 0 0 0 .586 1.591c.375.422.884.659 1.414.659s1.04-.237 1.414-.659A2.4 2.4 0 0 0 16 9.736c0 .295.052.588.152.861s.248.521.434.73a2 2 0 0 0 .649.488a1.8 1.8 0 0 0 1.53 0a2 2 0 0 0 .65-.488c.185-.209.332-.457.433-.73s.152-.566.152-.861c0-.974-1.108-3.85-1.618-5.121A.98.98 0 0 0 17.466 4H6.456a.99.99 0 0 0-.93.645C5.045 5.962 4 8.905 4 9.736c.023.59.241 1.148.611 1.567c.37.418.865.667 1.389.697m0 0c.328 0 .651-.091.94-.266A2.1 2.1 0 0 0 7.66 11h.681a2.1 2.1 0 0 0 .718.734c.29.175.613.266.942.266s.651-.091.94-.266c.29-.174.537-.427.719-.734h.681a2.1 2.1 0 0 0 .719.734c.289.175.612.266.94.266c.329 0 .652-.091.942-.266c.29-.174.536-.427.718-.734h.681c.183.307.43.56.719.734c.29.174.613.266.941.266a1.8 1.8 0 0 0 1.06-.351M5 12v7a1 1 0 0 0 1 1h2v-5h3v5h7a1 1 0 0 0 1-1v-7m-5 3v2h2v-2z"/>
                                                        </svg>
                                                    </div>
                                                    <div className="min-w-0">
                                                        <h3 className="text-base font-bold text-gray-900 leading-tight truncate">{branch.name}</h3>
                                                        <p className="text-xs text-gray-400 mt-0.5 truncate">{branch.address}</p>
                                                    </div>
                                                </div>
                                                <span className={`flex-shrink-0 px-2.5 py-1 rounded-full text-xs font-semibold capitalize ${getStatusColor(branch.status)}`}>
                                                    {branch.status}
                                                </span>
                                            </div>
                                        </div>
 
                                        {/* Divider */}
                                        <div className="mx-5 border-t border-gray-100" />
 
                                        {/* Details */}
                                        <div className="px-5 py-4 space-y-3">
                                            {/* Hours row */}
                                            <div className="flex items-center gap-2 text-sm text-gray-600">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" className="text-gray-400 flex-shrink-0">
                                                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l2.5 2.5M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2z"/>
                                                </svg>
                                                <span>{formatTime(branch.open_time)} – {formatTime(branch.close_time)}</span>
                                            </div>
 
                                            {/* Address row */}
                                            <div className="flex items-start gap-2 text-sm text-gray-600">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" className="text-gray-400 flex-shrink-0 mt-0.5">
                                                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/>
                                                </svg>
                                                <span className="leading-relaxed line-clamp-2">{branch.address}</span>
                                            </div>
 
                                            {/* Operating since row */}
                                            <div className="flex items-center gap-2 text-sm text-gray-600">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" className="text-gray-400 flex-shrink-0">
                                                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 2v3M16 2v3M3 8h18M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/>
                                                </svg>
                                                <span>Since {formatDate(branch.operating_start_date)}</span>
                                            </div>
                                        </div>
 
                                        {/* Footer actions */}
                                        <div className="px-5 pb-5 flex gap-2">
                                            <button
                                                onClick={() => handleEditClick(branch)}
                                                className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                                            >
                                                Edit
                                            </button>
                                            <button
                                                onClick={() => handleArchiveBranch(branch)}
                                                className="flex-1 px-4 py-2 text-sm font-medium text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
                                            >
                                                Archive
                                            </button>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                        <Pagination
                            page={branchPage}
                            totalItems={filteredBranches.length}
                            pageSize={BRANCH_PAGE_SIZE}
                            onPageChange={setBranchPage}
                        />
                    </>
                )}
 
                {/* Hero Banners Tab */}
                {activeTab === 'banners' && (
                    <div className="bg-white rounded-lg shadow-sm">
                        <div className="px-6 py-4 border-b border-gray-200 flex flex-wrap items-center justify-between gap-3 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Hero Banner Management</h2>
 
                            <div className="flex flex-wrap items-center gap-3">
                                {/* Search */}
                                <div className="relative">
                                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"/>
                                        </svg>
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Search banners..."
                                        value={bannerSearch}
                                        onChange={(e) => setBannerSearch(e.target.value)}
                                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] w-full sm:w-56"
                                    />
                                </div>
 
                                {/* Archived viewer button */}
                                <button
                                    onClick={openArchivedBannersModal}
                                    className="p-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg"
                                    title="View Archived Banners"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 6v10h12V9zm2 2h8v2H8zm0 4h8v2H8zM5 5v2h14V5z"/>
                                    </svg>
                                </button>
 
                                <button
                                    onClick={openAddBannerModal}
                                    className="bg-[#8B5A3C] hover:bg-[#6d4730] text-white font-medium px-4 py-2 rounded-lg transition-colors text-sm"
                                >
                                    + Add Banner
                                </button>
                            </div>
                        </div>
 
                        {bannersLoading ? (
                            <div className="divide-y divide-gray-200">
                                {Array.from({ length: 5 }).map((_, i) => (
                                    <div key={i} className="px-6 py-5 flex items-start gap-5">
                                        <SkeletonBlock className="w-28 h-16 rounded-lg flex-shrink-0" />
                                        <div className="flex-1 min-w-0 space-y-2">
                                            <SkeletonBlock className="h-4 w-1/3" />
                                            <SkeletonBlock className="h-3 w-2/3" />
                                            <SkeletonBlock className="h-3 w-1/4" />
                                        </div>
                                        <div className="flex items-center gap-2 flex-shrink-0">
                                            <SkeletonBlock className="w-7 h-7 rounded" />
                                            <SkeletonBlock className="w-7 h-7 rounded-lg" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : filteredBanners.length === 0 ? (
                            <div className="px-6 py-12 text-center text-gray-500">
                                {bannerSearch
                                    ? 'No banners match your search.'
                                    : 'No banners yet. Add your first hero banner.'}
                            </div>
                        ) : (
                            <div className="divide-y divide-gray-200">
                                {pagedFilteredBanners.map((banner) => {
                                    const displayStatus = getBannerDisplayStatus(banner)
                                    const startStr = formatBannerDate(banner.start_at)
                                    const endStr   = formatBannerDate(banner.end_at)
                                    return (
                                        <div key={banner.banner_id} className="px-6 py-5 hover:bg-gray-50 transition-colors">
                                            <div className="flex items-start gap-5">
                                                {/* Thumbnail */}
                                                <div className="w-28 h-16 rounded-lg overflow-hidden border border-gray-200 bg-gray-100 flex-shrink-0">
                                                    {banner.image_url
                                                        ? <img src={banner.image_url} alt={banner.title} className="w-full h-full object-cover" />
                                                        : <div className="w-full h-full flex items-center justify-center text-gray-400 text-xs">No image</div>
                                                    }
                                                </div>
 
                                                {/* Details */}
                                                <div className="flex-1 min-w-0">
                                                    <div className="flex items-center gap-2 mb-1">
                                                        <h3 className="font-semibold text-gray-800 truncate">{banner.title}</h3>
                                                        <span className={`px-2 py-0.5 rounded-full text-xs font-medium flex-shrink-0 ${getBannerStatusStyle(displayStatus)}`}>
                                                            {displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1)}
                                                        </span>
                                                    </div>
                                                    {banner.subtitle && <p className="text-sm text-gray-500 truncate mb-1">{banner.subtitle}</p>}
                                                    <div className="flex items-center gap-4 text-xs text-gray-400">
                                                        {(startStr || endStr) && (
                                                            <span>
                                                                {startStr && endStr ? `${startStr} – ${endStr}` : startStr ? `From ${startStr}` : `Until ${endStr}`}
                                                            </span>
                                                        )}
                                                        {banner.link_url && (
                                                            <a href={banner.link_url} target="_blank" rel="noreferrer"
                                                                className="text-[#8B5A3C] hover:underline truncate max-w-[180px]">
                                                                {banner.link_url}
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
 
                                                {/* Actions */}
                                                <div className="flex items-center gap-2 flex-shrink-0">
                                                    <button
                                                        onClick={() => openEditBannerModal(banner)}
                                                        className="p-1 text-blue-600 hover:bg-blue-50 rounded"
                                                        title="Edit banner"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                            <path fill="currentColor" d="m14.06 9l.94.94L5.92 19H5v-.92zm3.6-6c-.25 0-.51.1-.7.29l-1.83 1.83l3.75 3.75l1.83-1.83c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z"/>
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={() => handleArchiveBanner(banner.banner_id)}
                                                        className="p-2 text-red-600 hover:bg-red-50 rounded-lg"
                                                        title="Archive banner"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                            <path fill="currentColor" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                <Pagination
                                    page={bannerPage}
                                    totalItems={filteredBanners.length}
                                    pageSize={BANNER_PAGE_SIZE}
                                    onPageChange={setBannerPage}
                                />
                            </div>
                            
                        )}
 
                        {/* Search result count */}
                        {!bannersLoading && bannerSearch && (
                            <div className="px-6 py-3 border-t border-gray-200 bg-gray-50 rounded-b-lg">
                                <p className="text-sm text-gray-500">
                                    Showing <span className="font-medium text-gray-700">{filteredBanners.length}</span> of{' '}
                                    <span className="font-medium text-gray-700">{banners.length}</span> banners
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>
 
            {/* Branch Add/Edit Modal */}
            {(showAddModal || showEditModal) && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={closeBranchModal} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-xl font-bold text-gray-800">{showAddModal ? 'Add Branch' : 'Edit Branch'}</h2>
                            <p className="text-sm text-gray-500 mt-1">
                                {showAddModal ? 'Create a new branch with its hours, owner, and contact details.' : "Update this branch's hours, contact, or ownership details."}
                            </p>
                        </div>
                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">                                <div className="col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Branch Name <span className="text-red-500">*</span></label>
                                    <input type="text" placeholder="Enter Branch Name" value={branchFormData.name}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, name: e.target.value })}
                                        maxLength={100}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                        <p className="text-xs text-gray-500 mt-1">{branchFormData.name.length}/100 characters</p>
                                </div>
                                <div className="col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Address <span className="text-red-500">*</span></label>
                                    <textarea rows="3" placeholder="Enter Branch Address" value={branchFormData.address}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, address: e.target.value })}
                                        maxLength={255}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                        <p className="text-xs text-gray-500 mt-1">{branchFormData.address.length}/255 characters</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Open Time <span className="text-red-500">*</span></label>
                                    <input type="time" value={branchFormData.open_time}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, open_time: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Close Time <span className="text-red-500">*</span></label>
                                    <input type="time" value={branchFormData.close_time}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, close_time: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Operating Start Date <span className="text-red-500">*</span></label>
                                    <input type="date" value={branchFormData.operating_start_date}
                                        min="2017-12-13"
                                        onChange={(e) => setBranchFormData({ ...branchFormData, operating_start_date: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                                    <select value={branchFormData.status}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, status: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]">
                                        <option value="operating">Operating</option>
                                        <option value="closed">Closed</option>
                                        <option value="maintenance">Maintenance</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>
                                <div className="col-span-2 grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Branch Owner <span className="text-red-500">*</span></label>
                                        <input type="text" placeholder="Enter Branch Owner" value={branchFormData.branch_owner}
                                            onChange={(e) => setBranchFormData({ ...branchFormData, branch_owner: e.target.value })}
                                            maxLength={100}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                            <p className="text-xs text-gray-500 mt-1">{branchFormData.branch_owner.length}/100 characters</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Owner Email <span className="text-red-500">*</span></label>
                                        <input type="email" placeholder="owner@example.com" value={branchFormData.email}
                                            onChange={(e) => setBranchFormData({ ...branchFormData, email: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Business Email</label>
                                        <input type="email" placeholder="cgtvm@kaperk.com" value={branchFormData.business_email}
                                            onChange={(e) => setBranchFormData({ ...branchFormData, business_email: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                        <p className="text-xs text-gray-500 mt-1">Receives EOD/sales reports. Separate from the login identity.</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Manager</label>
                                        <input type="text" placeholder="Enter Manager Name"
                                            value={branchFormData.owner_is_manager ? branchFormData.branch_owner : branchFormData.manager}
                                            disabled={branchFormData.owner_is_manager}
                                            onChange={(e) => setBranchFormData({ ...branchFormData, manager: e.target.value })}
                                            maxLength={100}
                                            className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] ${
                                                branchFormData.owner_is_manager ? 'bg-gray-100 text-gray-400' : ''
                                            }`} />
                                        <p className="text-xs text-gray-500 mt-1">
                                            {(branchFormData.owner_is_manager ? branchFormData.branch_owner.length : branchFormData.manager.length)}/100 characters
                                        </p>
                                    </div>
                                </div>
                                <div className="col-span-2 flex items-center gap-2 -mt-2">
                                    <input
                                        type="checkbox"
                                        id="owner-is-manager"
                                        checked={branchFormData.owner_is_manager}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, owner_is_manager: e.target.checked })}
                                        className="w-4 h-4 accent-[#8B5A3C] cursor-pointer"
                                    />
                                    <label htmlFor="owner-is-manager" className="text-sm text-gray-600 cursor-pointer">
                                        Branch owner is also the branch manager
                                    </label>
                                </div>
                                <div className="col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">TIN</label>
                                    <input type="text" placeholder="e.g. 123-456-789-000" value={branchFormData.tin}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, tin: e.target.value })}
                                        maxLength={20}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                        <p className="text-xs text-gray-500 mt-1">{branchFormData.tin.length}/20 characters</p>
                                </div>
                                <div className="col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Facebook Page Link</label>
                                    <input type="url" placeholder="https://facebook.com/..." value={branchFormData.facebook_url}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, facebook_url: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
                                    <input type="tel" placeholder="09xx xxx xxxx" value={branchFormData.phone_number}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, phone_number: e.target.value })}
                                        maxLength={15}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                        <p className="text-xs text-gray-500 mt-1">{branchFormData.phone_number.length}/15 characters</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Telephone Number</label>
                                    <input type="tel" placeholder="(02) xxx xxxx" value={branchFormData.telephone_number}
                                        onChange={(e) => setBranchFormData({ ...branchFormData, telephone_number: e.target.value })}
                                        maxLength={15}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]" />
                                        <p className="text-xs text-gray-500 mt-1">{branchFormData.telephone_number.length}/15 characters</p>
                                </div>
                            </div>
                            {/* --- Branch Documents (image/PDF upload UI) ---
                            <div className="col-span-2">
                                <label className="block text-sm font-medium text-gray-700 mb-2">Branch Documents</label>

                                {showEditModal && loadingBranchDocs && (
                                    <p className="text-sm text-gray-400 mb-2">Loading existing documents...</p>
                                )}

                                <div className="space-y-4">
                                    {DOCUMENT_CATEGORIES.map((cat) => {
                                        const existingDocs = groupedBranchDocuments[cat.key] || []
                                        const stagedFiles = newDocFilesByCategory[cat.key] || []

                                        return (
                                            <div key={cat.key} className="border border-gray-200 rounded-lg p-3">
                                                <p className="text-sm font-medium text-gray-700 mb-2">{cat.label}</p>

                                                <input
                                                    type="file"
                                                    multiple
                                                    accept=".pdf,.png,.jpg,.jpeg,image/png,image/jpeg,application/pdf"
                                                    onChange={(e) => {
                                                        const files = Array.from(e.target.files || [])
                                                        setNewDocFilesByCategory(prev => ({
                                                            ...prev,
                                                            [cat.key]: [...(prev[cat.key] || []), ...files]
                                                        }))
                                                        e.target.value = ''
                                                    }}
                                                    className="w-full text-sm px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                                />

                                                {existingDocs.length > 0 && (
                                                    <ul className="mt-2 space-y-1">
                                                        {existingDocs.map((doc) => (
                                                            <li key={doc.document_id} className="flex items-center justify-between text-sm bg-gray-50 px-3 py-1.5 rounded">
                                                                <a href={doc.file_url} target="_blank" rel="noreferrer" className="text-[#8B5A3C] hover:underline truncate">
                                                                    {doc.file_name}
                                                                </a>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleDeleteBranchDocument(doc.document_id)}
                                                                    className="text-red-600 hover:text-red-800 text-xs font-medium ml-2"
                                                                >
                                                                    Remove
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}

                                                {stagedFiles.length > 0 && (
                                                    <ul className="mt-2 space-y-1">
                                                        {stagedFiles.map((file, idx) => (
                                                            <li key={`${file.name}-${idx}`} className="flex items-center justify-between text-sm bg-amber-50 px-3 py-1.5 rounded">
                                                                <span className="truncate">{file.name}</span>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setNewDocFilesByCategory(prev => ({
                                                                        ...prev,
                                                                        [cat.key]: prev[cat.key].filter((_, i) => i !== idx)
                                                                    }))}
                                                                    className="text-red-600 hover:text-red-800 text-xs font-medium ml-2"
                                                                >
                                                                    Remove
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            --- end disabled block --- */}
                        </div>
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button onClick={closeBranchModal} className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button onClick={showAddModal ? handleAddBranch : handleUpdateBranch}
                                className="px-6 py-2 bg-[#8B5A3C] text-white rounded-lg font-medium hover:bg-[#6d4730]">
                                {showAddModal ? 'Add Branch' : 'Update Branch'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
 
            {/* Archived Branches Modal */}
            {showArchivedBranchesModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowArchivedBranchesModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 space-y-3">
                            <div>
                                <h2 className="text-xl font-bold text-gray-800">Archived Branches</h2>
                                <p className="text-sm text-gray-500 mt-1">Branches with inactive status. Reinstate to set them back to operating.</p>
                            </div>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search archived branches..."
                                    value={archivedBranchSearch}
                                    onChange={(e) => setArchivedBranchSearch(e.target.value)}
                                    className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                />
                            </div>
                        </div>

                        <div className="overflow-y-auto flex-1">
                            {loadingArchivedBranches ? (
                                <div className="px-6 py-10 text-center text-gray-500">Loading archived branches...</div>
                            ) : filteredArchivedBranches.length === 0 ? (
                                <div className="px-6 py-10 text-center text-gray-500">
                                    {archivedBranchSearch ? 'No archived branches match your search.' : 'No archived branches found.'}
                                </div>
                            ) : (
                                <table className="w-full">
                                    <thead className="bg-gray-50 border-b border-gray-200">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Branch</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Address</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Hours</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white">
                                        {pagedArchivedBranches.map((branch) => (
                                            <tr key={branch.branch_id}>
                                                <td className="px-6 py-4">
                                                    <p className="font-medium text-gray-800">{branch.name}</p>
                                                    <p className="text-xs text-gray-500 mt-0.5">Since {formatDate(branch.operating_start_date)}</p>
                                                </td>
                                                <td className="px-6 py-4 text-sm text-gray-600 max-w-xs truncate">{branch.address}</td>
                                                <td className="px-6 py-4 text-sm text-gray-600 whitespace-nowrap">
                                                    {formatTime(branch.open_time)} – {formatTime(branch.close_time)}
                                                </td>
                                                <td className="px-6 py-4">
                                                    <button
                                                        onClick={() => handleReinstateBranch(branch)}
                                                        className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors"
                                                    >
                                                        Reinstate
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                            <Pagination
                                page={archivedBranchPage}
                                totalItems={filteredArchivedBranches.length}
                                pageSize={ARCHIVE_PAGE_SIZE}
                                onPageChange={setArchivedBranchPage}
                            />
                        </div>
 
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end flex-shrink-0">
                            <button
                                onClick={() => setShowArchivedBranchesModal(false)}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
 
            {/* Archived Banners Modal */}
            {showArchivedBannersModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setShowArchivedBannersModal(false)} />
                    <div className="relative bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 space-y-3">
                            <div>
                                <h2 className="text-xl font-bold text-gray-800">Archived Banners</h2>
                                <p className="text-sm text-gray-500 mt-1">Restore archived banners to make them visible again across branches.</p>
                            </div>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search archived banners..."
                                    value={archivedBannerSearch}
                                    onChange={(e) => setArchivedBannerSearch(e.target.value)}
                                    className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                />
                            </div>
                        </div>
 
                        <div className="overflow-y-auto flex-1">
                            {loadingArchivedBanners ? (
                                <div className="px-6 py-10 text-center text-gray-500">Loading archived banners...</div>
                            ) : filteredArchivedBanners.length === 0 ? (
                                <div className="px-6 py-10 text-center text-gray-500">
                                    {archivedBannerSearch ? 'No archived banners match your search.' : 'No archived banners found.'}
                                </div>
                            ) : (
                                <div className="divide-y divide-gray-200">
                                    {pagedArchivedBanners.map((banner) => {
                                        const startStr = formatBannerDate(banner.start_at)
                                        const endStr   = formatBannerDate(banner.end_at)
                                        return (
                                            <div key={banner.banner_id} className="px-6 py-5 flex items-start gap-5 hover:bg-gray-50 transition-colors">
                                                {/* Thumbnail */}
                                                <div className="w-24 h-14 rounded-lg overflow-hidden border border-gray-200 bg-gray-100 flex-shrink-0">
                                                    {banner.image_url
                                                        ? <img src={banner.image_url} alt={banner.title} className="w-full h-full object-cover" />
                                                        : <div className="w-full h-full flex items-center justify-center text-gray-400 text-xs">No image</div>
                                                    }
                                                </div>
 
                                                {/* Details */}
                                                <div className="flex-1 min-w-0">
                                                    <p className="font-semibold text-gray-800 truncate">{banner.title}</p>
                                                    {banner.subtitle && <p className="text-sm text-gray-500 truncate">{banner.subtitle}</p>}
                                                    {(startStr || endStr) && (
                                                        <p className="text-xs text-gray-400 mt-1">
                                                            {startStr && endStr ? `${startStr} – ${endStr}` : startStr ? `From ${startStr}` : `Until ${endStr}`}
                                                        </p>
                                                    )}
                                                </div>
 
                                                {/* Reinstate */}
                                                <button
                                                    onClick={() => handleReinstateBanner(banner.banner_id)}
                                                    className="flex-shrink-0 px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors"
                                                >
                                                    Reinstate
                                                </button>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
 
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end flex-shrink-0">
                            <button
                                onClick={() => setShowArchivedBannersModal(false)}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Close
                            </button>
                        </div>
                        <Pagination
                            page={archivedBannerPage}
                            totalItems={filteredArchivedBanners.length}
                            pageSize={ARCHIVE_PAGE_SIZE}
                            onPageChange={setArchivedBannerPage}
                        />
                    </div>
                </div>
            )}
 
            {/* Banner Add Modal */}
            {showAddBannerModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowAddBannerModal(false); resetBannerForm() }} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-xl font-bold text-gray-800">Add Hero Banner</h2>
                            <p className="text-sm text-gray-500 mt-1">Create a new promotional banner and choose which branches show it.</p>
                        </div>
                        {renderBannerFormBody()}
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button onClick={() => { setShowAddBannerModal(false); resetBannerForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button onClick={handleAddBanner} disabled={!hasAddBannerChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${
                                    !hasAddBannerChanges ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                }`}>
                                Save Banner
                            </button>
                        </div>
                    </div>
                </div>
            )}
 
            {/* Banner Edit Modal */}
            {showEditBannerModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowEditBannerModal(false); setEditingBanner(null); resetBannerForm() }} />
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4">
                            <h2 className="text-xl font-bold text-gray-800">Edit Hero Banner</h2>
                            <p className="text-sm text-gray-500 mt-1">Update this banner's content, availability, or branch visibility.</p>
                        </div>
                        {renderBannerFormBody()}
                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button onClick={() => { setShowEditBannerModal(false); setEditingBanner(null); resetBannerForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300">Cancel</button>
                            <button onClick={handleUpdateBanner} disabled={!hasEditBannerChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${
                                    !hasEditBannerChanges ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                }`}>
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}